// Makes one click mean one record.
//
// A form that only shows a spinner while saving is still fully clickable, so a
// second click runs the whole submit handler again and creates a duplicate. A
// React state flag ("isSubmitting") is not enough on its own: two clicks in the
// same tick can both read the old value before React re-renders. This closes
// over a plain variable, so the second call sees the flag immediately.
//
// Usage — keep the guard in a ref so it survives re-renders:
//   const guard = useRef(createSubmitGuard());
//   const handleSubmit = (e) => { e.preventDefault(); guard.current(doSave); };
//
// Returns { skipped: true } when a call was suppressed, otherwise
// { skipped: false, value } with whatever the wrapped function returned. The
// flag is always cleared, including when the save throws, so a failed submit
// never leaves the button permanently dead.
export function createSubmitGuard() {
  let inFlight = false;

  return async function run(fn) {
    if (inFlight) return { skipped: true };
    inFlight = true;
    try {
      const value = await fn();
      return { skipped: false, value };
    } finally {
      inFlight = false;
    }
  };
}
